module.exports = __webpack_public_path__ + "static/media/jaw.cac05e62.jpg";